import { Toolbar as MUIToolbar, ToolbarProps as MUIToolbarProps } from '@mui/material';

export interface ToolbarProps extends MUIToolbarProps {}

export const Toolbar = MUIToolbar;
